export default {"src":"/_next/static/media/check-circle-green.43d6f090.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};